<template>
    <div>
      <tab @switchTime="switchTime">
        <template> 发布日期 </template>
      </tab>
      <div class="set-min-contain" style="margin-top:0.32rem">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="query"
        >
          <!-- <search tab="anchor"></search> -->
          <List
            :info="item"
            :index="index + 1"
            v-for="(item, index) in info.data"
            :key="index"
          />
        </van-list>
        <More />
      </div>
    </div>
  </template>
  
  <script>
  import tab from "@/modules/carrierList/tab.vue";
  import List from "./list.vue";
  import search from "@/modules/toSearch/tosearch.vue";
  const page = {
    pageNum: 1,
    pageSize: 25,
      sort: 'views',//排序方式
    order: "desc",
    type:1,
  };
  export default {
    data() {
      return {
        count: 0,
        loading: true,
        params: page,
        info: {},
      };
    },
    components: { tab, search, List },
    computed: {
      finished() {
        return this.info?.paging?.count === this.info?.data?.length;
      },
      isVip: (_this = this) =>
        _this.$store.state.userLevel && _this.$store.state.userLevel < 1000,
      finishedText: (_this = this) =>
        !_this.isVip ? "升级权益查看更多数据" : "没有更多了",
    },
    methods: {
      parse(obj){
          if(this.params.index === 1){
            return obj
          }else{
            return {
              paging:obj.paging,
              data:this.info?.data? this.info.data.concat(obj.data) : obj.data
            }
          }
        },
      switchTime(val) {
          this.info = [];
          this.count = 0;
          this.params = { ...this.params, ...val };
          this.params.pageNum = 1;
          this.info = [];
          this.query();

      },
      query() {
        this.$get({
          road: "hotOpusRank",
          params: { ...this.params},
          version: "v22",
        }).then((res) => {
          this.params.pageNum++;
          this.loading = false;
          this.info = this.parse(res.data);
        });
      },
    },
  };
  </script>
  
  <style scoped></style>
